import cs from 'classnames';
import React from 'react';
import { LoadingLabel } from 'shared/components/Loading';
import { SummaryField } from 'shared/summary/SummaryField';
import { SummaryHeader } from 'shared/summary/SummaryHeader';
import { SummarySection } from 'shared/summary/SummarySection';
import { slugs, useRentalSteps } from '../../app/steps';
import { DeliveryAddressType, EnumChoicesTypeInfoFragment } from '../../generated.graphql';
import { BaseSummaryProps } from './types';
import { getEnumDisplay, getTimePeriodDisplay, YesNoLabel } from './utils';


interface Props extends BaseSummaryProps {
  homeTypeSourceEnum?: EnumChoicesTypeInfoFragment | null
}


export const AddressSummary = ({ application, homeTypeSourceEnum }: Props) => {
  const steps = useRentalSteps({slug: slugs.address});
  const address = application?.address;
  const livingSituation = application?.livingSituation;
  const addressErrors = application?.validation?.address;
  const livingErrors = application?.validation?.livingSituation;
  const isInvalid = !!addressErrors;
  
  return (
    <SummarySection>
      <SummaryHeader step={steps.this} className={cs(isInvalid && 'text-danger')}>My Address</SummaryHeader>
      {address && livingSituation ? (
        <>
          <SummaryField label="Residential address" field="residentialAddress" value={address.residentialAddress?.fullAddress} errors={addressErrors} />
          <SummaryField label="Living situation" field="homeType" value={getEnumDisplay(livingSituation.homeType, homeTypeSourceEnum)} errors={livingErrors} />
          <SummaryField label="Lived there" optional value={getTimePeriodDisplay(livingSituation.homeDurationYears, livingSituation.homeDurationMonths)} />

          {address.deliveryAddressType === DeliveryAddressType.Residential && (
            <SummaryField
              label="Delivery address same as residential"
              field="deliveryAddress"
              value={<YesNoLabel value={true} />}
              errors={addressErrors}
            />
          )}
          {address.deliveryAddressType === DeliveryAddressType.Dealer && (
            <SummaryField
              label="Deliver to my local dealer"
              field="dealer"
              value={[address.dealer?.name, address.dealer?.city, address.dealer?.state].join(' ')}
              errors={addressErrors}
            />
          )}
          {address.deliveryAddressType === DeliveryAddressType.Custom && (
            <SummaryField label="Delivery address" field="deliveryAddress" value={address.deliveryAddress?.fullAddress} errors={addressErrors} />
          )}

          <SummaryField data={address} field="deliveryInstructions" errors={addressErrors} optional />
        </>
      ) : (
        <LoadingLabel alignment="left" />
      )}
    </SummarySection>
  );
}